// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__pGTVk","footer":"ModalUpdate_footer__lntXi"};